import type { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';

import { DocumentTitle } from 'src/components/DocumentTitle';
import { dpConfig } from 'src/config';

type ErrorSectionProps = {
  code?: number;
  title: string;
  description: string;
  action: ReactElement;
};

export function ErrorSection({
  code,
  title,
  description,
  action,
}: ErrorSectionProps): ReactElement {
  const { t } = useTranslation('errors');

  return (
    <div className='m-auto text-center'>
      <DocumentTitle title={title} />
      {code && (
        <p className='font-semibold text-base text-primary-default'>{code}</p>
      )}
      <h1 className='mt-4 font-bold text-3xl text-layout-foreground tracking-tight sm:text-5xl'>
        {title}
      </h1>
      <p className='mt-6 text-base text-layout-foreground-secondary leading-7'>
        {description}
      </p>
      <div className='mt-10 flex items-center justify-center gap-x-6'>
        {action}
        <a
          className='font-semibold text-layout-foreground text-sm'
          href={dpConfig.support}
          rel='noreferrer'
          target='_blank'
        >
          {t('Contact support')} <span aria-hidden='true'>&rarr;</span>
        </a>
      </div>
    </div>
  );
}
